export default __webpack_public_path__ + "static/media/element_60.c7f95741.avif";